import { fundingSource } from '@/modules/api/delete/fundingSource'
import { athleticsMessage } from '@/modules/api/delete/athleticsMessage'

export const Delete = {
  fundingSource,
  athleticsMessage
}
